/* eslint-disable max-len */
import React from "react";
import { CloseIcon } from "../../../components/Icons";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { useModal } from "../../../context/ModalContext";
import { useNavigate } from "react-router-dom";
import { PAGES_PATH } from "../../../navigation/params";
import { modalStorageKeys } from "../../../config/params";
import WellnessPlanReminderCardList from "./WellnessPlanReminderCardList";
import { markPetsShownForModal } from "../../../services/wellness-plans-by-user/wellness-plan-by-user.service";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { useCombinedAlertsDataStore } from "../../../hooks";

const WellnessPlanReminders = () => {
  const navigate = useNavigate();
  const { closeModal } = useModal();

  const {
    endsSoonWPData,
    recentlyEndedWPData,
    failedRenewalsAfterGracePeriodWPData,
    failedRenewalsWPData,
  } = useCombinedAlertsDataStore();


  const handleModalClose = () =>{
    if (recentlyEndedWPData.length) {
      markPetsShownForModal(modalStorageKeys.nonAutoRenewEndedPlans,
        recentlyEndedWPData.map((petData)=>petData.petId));
    }
    if (endsSoonWPData.length) {
      markPetsShownForModal(modalStorageKeys.wellnessPlansEndingSoon,
        endsSoonWPData.map((petData)=>petData.petId));
    }
    if (failedRenewalsWPData.length) {
      markPetsShownForModal(modalStorageKeys.autoRenewEndedPlans,
        failedRenewalsWPData.map((petData)=>petData.petId));
    }
    if (failedRenewalsAfterGracePeriodWPData.length) {
      markPetsShownForModal(modalStorageKeys.autoRenewUnsuccessfulEndedPlans,
        failedRenewalsAfterGracePeriodWPData.map((petData)=>petData.petId));
    }
    const allPlans = [...recentlyEndedWPData,
      ...endsSoonWPData, ...failedRenewalsWPData, ...failedRenewalsAfterGracePeriodWPData];

    allPlans.forEach((petData) => {
      userActivityLogger(MIXPANEL_EVENTS.USER_CLICK_GOT_IT_IN_POPUP, {
        pet_name: petData.petName,
        plan_name: petData.wellnessPlanName,
        popup_type: "multipet_alert_modal",
      });
    });
    closeModal();
  };

  const handlePrimaryCta = () =>{
    const allPlans = [...recentlyEndedWPData,
      ...endsSoonWPData, ...failedRenewalsWPData, ...failedRenewalsAfterGracePeriodWPData];

    allPlans.forEach((petData) => {
      userActivityLogger(MIXPANEL_EVENTS.USER_CLICKS_REVIEW_NEW_TOTALCARE_PLANS, {
        is_auto_renewal_on: petData.isAutoRenewal,
        pet_name: petData.petName,
        plan_name: petData.wellnessPlanName,
        referred_from: "multipet_alert_modal",
      });
    });
    handleModalClose();
    navigate(PAGES_PATH.USER_PROFILE+"/"+PAGES_PATH.USER_BILLING);
  };


  return (
    <div className="w-full h-full flex flex-col justify-between xl:w-[38rem] max-h-[90vh] md:max-h-[85vh] lg:max-h-[80vh] xl:max-h-[33rem] bg-gray-2 p-8 rounded-3xl">
      <div className="flex justify-end">
        <CloseIcon
          onClick={handleModalClose}
          className="text-light-black cursor-pointer"
        />
      </div>
      <div>
        <div className="text-2xl font-semibold text-center">
          <p>Updates on your TotalCare Plans
          </p>
        </div>
        <div className="text-sm text-center pt-2 pb-4">
          Your TotalCare renewal options might look a little different this year.
          Take a moment to see what&apos;s new by reviewing your pet&apos;s options.
        </div>
      </div>

      <div className="overflow-y-auto h-full scrollbar-thin pe-1">
        <WellnessPlanReminderCardList />
      </div>
      <div className="flex flex-col gap-3">
        <div className="pt-2 w-full">
          <StyledBookingFlowButton
            disabled={false}
            fullWidth
            color="primary"
            className={"!w-full !font-semibold !border-1 !border-gray-4 hover:!bg-black !h-[2.5rem] !text-sm" }
            size="small"
            onClick={handlePrimaryCta}
          >
            Review New Plans
          </StyledBookingFlowButton>
        </div>
      </div>
    </div>
  );
};

export default WellnessPlanReminders;
